import { render } from "./MachinesView.vue?vue&type=template&id=cb0b2a1a&scoped=true"
import script from "./MachinesView.vue?vue&type=script&lang=js"
export * from "./MachinesView.vue?vue&type=script&lang=js"

import "./MachinesView.vue?vue&type=style&index=0&id=cb0b2a1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb0b2a1a"]])

export default __exports__